export default {
  namespaced: true,
  state: {
    stripe: null,
  },
  getters: {
    stripe: state => state.stripe,
  },
  mutations: {
    SET_STRIPE(state, stripe) {
      state.stripe = stripe
    },
  },
}
